<template>
  <section class="full-text">
    <LineText :title="data.lineText" />
    <div class="c-container c-container--small">
      <p
        v-for="(paragraph, i) in data.content"
        :key="i"
        data-anim="paragraph"
      >{{ paragraph }}</p>
    </div>
  </section>
</template>

<script>
import LineText from '@/components/LineText.vue';

export default {
  name: 'FullText',

  components: {
    LineText,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.full-text p {
  display: inline-block;
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
